<template>
  <v-card style="max-width: 400px; min-width: 300px; margin: auto">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card
          color="#efefef"
          class="back--text"
          @click="setAction(type, task)"
        >
          <v-layout row p1-2>
            <v-flex xs9>
              <v-card-title primary-title>
                <div class="member_name">
                  <div>{{ task.name }}</div>
                  <span class="caption">{{ task.uc ? task.uc.id : "" }}</span>
                </div>
              </v-card-title>
            </v-flex>
            <v-flex xs3 pt-3>
              <v-avatar :tile="false" size="46" color="grey lighten-4">
                <v-img class="elevation-6" :src="avatar"></v-img>
              </v-avatar>
            </v-flex>
          </v-layout>
          <v-divider light></v-divider>
          <v-card-actions class="pa-2">
            <v-flex sm6>
              <span>{{
                task.saved_at || task.signedcontract_at | formatarDate
              }}</span>
            </v-flex>
            <v-flex sm6>
              <v-btn
                small
                round
                dark
                :color="badgeColor"
                v-if="showStatus"
                style="height: 19px; font-size: 10px"
              >
                {{ task.uc ? task.uc.status : task.status }}
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { eventBus } from "../../../main";
export default {
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    showStatus: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      default: () => false,
    },
  },
  computed: {
    badgeColor() {
      const mappings = {
        Design: "purple",
        "Feature Request": "teal",
        Backend: "blue",
        QA: "green",
        default: "teal",
      };
      return mappings[this.task.type] || mappings.default;
    },
    avatar() {
      if (this.task.gender === "M") {
        return "https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light";
      } else {
        return "https://avataaars.io/";
      }
    },
  },
  methods: {
    setAction: function (type, object) {
      if (type === "subscriptions") this.editLead(object);
    },
    editLead: function (lead) {
      this.loading = true;
      // console.log('lead1: ', newLead)
      eventBus.$emit("Lead", lead);
      this.loading = false;
      eventBus.$emit("dialog", true); // emit the event to the bus
    },
  },
};
</script>
<style scoped>
.member_name {
  font-weight: 400;
}
</style>
